module.exports = __webpack_public_path__ + "img/Trax2.7c4d6da1.png";